<template>
    <transition name="fimark">
        <div v-show="isMark.show" class="list-mark">
            <div class="header">
                <div @click="hideMark" class="list-icon"></div>
                <div class="header-icon"></div>
            </div>
            <ul class="link-list">
                <li @click="listHandle"><router-link :to="{name:'flatindexmobile'}">首页</router-link></li>
                <li @click="listHandle"><router-link :to="{name:'aboutusmobile'}">关于我们</router-link></li>
                <li @click="listHandle"><router-link :to="{name:'cooperatemobile'}">商务合作</router-link></li>
                <li @click="listHandle"><router-link :to="{name:'helpcentermobile'}">帮助中心</router-link></li>
                <!-- <li>商务合作</li>
                <li>帮助中心</li> -->
            </ul>
        </div>
    </transition>
</template>
<style lang="scss" scoped>

</style>
<script>
export default {
    data() {
        return {
        }
    },
    props: {
        isMark: {
            Object,
            default: function(){
                return {}
            }
        },
        isShow:{
            type:Boolean,
            default:false
        }
    },
    methods:{
        hideMark(){
            this.isMark.show=false
            // this.$emit('hidemark',false);
        },
        listHandle(){
            this.isMark.show=false
        }
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?5c996988